module.exports = __webpack_public_path__ + "img/MapPicsBabylonianBasin.be8daf35.webp";